<ng-container *ngIf="hasContainer; else headerTemplate">
    <ng-container *ngTemplateOutlet="headerTemplate; context: { optionExist: true }"></ng-container>
    <ng-container *ngIf="isExpanded">
        <div class="pills-border">
            @for (pill of formPills; track pill.id) {
                <button ds-pill size="small" [selected]="pill.active" [disabled]="pill.disabled" (click)="onFormSwitch(pill)">
                    {{ pill.title }}
                </button>
            }
        </div>
        <div
            msOptionGroupRenderer
            class="mesh-container {{ scoreOptionsClass }}"
            [ngClass]="{ 'mobile-device': isMobile }"
            [resetClass]="true"
            [optionPickClass]="'.option-group'">
            <ng-container
                *ngTemplateOutlet="
                    optionTemplate;
                    context: {
                        optionGroup: activeOptionGroup,
                        showBottmBorder: false,
                        lastRowOptionsCount: lastRowOptionsCount,
                    }
                "></ng-container>
            <ng-container *ngIf="showAllOptions || isShowMore">
                <ng-container
                    *ngTemplateOutlet="
                        optionTemplate;
                        context: { optionGroup: moreOptionGroup, showBottmBorder: false, lastRowOptionsCount: lastRowOptionsCountMore }
                    "></ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-container>
<ng-template #optionTemplate let-optionGroup="optionGroup" let-showBottmBorder="showBottmBorder" let-lastRowOptionsCount="lastRowOptionsCount">
    <ms-grid-option-group
        *ngIf="optionGroup"
        [activeEvent]="event"
        [activeOptionGroup]="optionGroup"
        [showParticipantImage]="showParticipantImage"
        [enableOptionImages]="enableOptionImages"
        [optionImages]="optionImages"
        [tracking]="{ source: tracking.source }"
        [betDetails]="betDetails"
        [sourceOfPick]="sourceOfPick"
        [showBottomBorder]="showBottmBorder"
        [lastRowOptionsCount]="lastRowOptionsCount"></ms-grid-option-group>
</ng-template>
@if (hasMore) {
    <div class="show-more-less-button" [ngClass]="isShowMore ? 'expanded' : ''" (click)="onShowMoreLessButtonToggle()">
        <button ds-button kind="tertiary" variant="flat" size="small">
            <span class="more-items">{{ this.showMoreLessText }}</span>
            <span slot="end">
                <ng-container *ngTemplateOutlet="IconTemplate"></ng-container>
            </span>
        </button>
    </div>
    <ng-template #IconTemplate>
        <vn-icon class="goal-scorer-show-more" [name]="isShowMore ? 'theme-up' : 'theme-down'"></vn-icon>
    </ng-template>
}
<ng-template #headerTemplate let-optionExist="optionExist">
    <ms-event-header
        [ngClass]="{ 'no-option': !optionExist }"
        [isEventNameALink]="isEventNameALink"
        [event]="event"
        [eventUrl]="eventUrl"
        [media]="media"
        [isAllBetsButtonVisible]="isAllBetsButtonVisible"
        [module]="module"
        [couponType]="couponType"
        [isOptionsExist]="hasContainer"
        (headerDetails)="getEventDetails($event)"></ms-event-header>
</ng-template>
